import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M16 14v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 14v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 20h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 20h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 16v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 22h.01", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CloudHail";
const CloudHail = memo(themed(Icon));
export {
  CloudHail
};
//# sourceMappingURL=cloud-hail.js.map
